import type { AdminStoryStatus, Lang, Money, SourceType } from '@fonus/shared';

export const STATUS_LABEL: Record<AdminStoryStatus, string> = {
  DRAFT: 'Черновик',
  IN_REVIEW: 'На проверке',
  SCHEDULED: 'Запланирована',
  PUBLISHED: 'Опубликована',
  ARCHIVED: 'Архив',
};
export const SOURCE_LABEL: Record<SourceType, string> = {
  FOLK: 'Народная',
  AI: 'AI',
  AUTHOR: 'Авторская',
};
export const LANG_LABEL: Record<Lang, string> = {
  uz: 'Узбекский',
  ru: 'Русский',
  en: 'Английский',
};
export const LANG_SHORT: Record<Lang, string> = { uz: 'uz', ru: 'ru', en: 'en' };

const tz = 'Asia/Tashkent';
/** «18 окт., 18:00» in Tashkent time. */
export function tashkent(iso: string | null | undefined, withYear = false): string {
  if (!iso) return '—';
  return new Intl.DateTimeFormat('ru-RU', {
    timeZone: tz,
    day: 'numeric',
    month: 'short',
    ...(withYear ? { year: 'numeric' } : {}),
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(iso));
}
export function tashkentDate(iso: string): string {
  return new Intl.DateTimeFormat('ru-RU', { timeZone: tz, day: 'numeric', month: 'long' }).format(
    new Date(iso),
  );
}
/** `datetime-local` value in Tashkent time ↔ ISO (Tashkent is UTC+5, no DST). */
export const toLocalInput = (iso: string) =>
  new Date(new Date(iso).getTime() + 5 * 3600_000).toISOString().slice(0, 16);
export const fromLocalInput = (v: string) =>
  new Date(new Date(`${v}:00Z`).getTime() - 5 * 3600_000).toISOString();

export const num = (n: number) => new Intl.NumberFormat('ru-RU').format(Math.round(n));
export const usd = (n: number) =>
  `$${n < 1 ? n.toFixed(2).replace('.', ',') : new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 2 }).format(n)}`;
export const money = (m: Money) =>
  m.uzs !== null ? `${usd(m.usd)} ≈ ${num(m.uzs)} сум` : usd(m.usd);
export const credits = (n: number) => `${num(n)} кр.`;

export function duration(sec: number | null): string {
  if (sec === null) return '—';
  return `${String(Math.floor(sec / 60))}:${String(sec % 60).padStart(2, '0')}`;
}

export const ago = (iso: string) => {
  const s = Math.round((Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 60) return 'только что';
  if (s < 3600) return `${String(Math.floor(s / 60))} мин назад`;
  return tashkent(iso);
};
